import React from 'react';
import { Group, Line, Text } from 'react-konva';
import { DimensionGuide as DimensionGuideType } from '../types';

type DimensionGuideProps = {
  guide: DimensionGuideType;
};

const TICK_SIZE = 4;

const DimensionGuide: React.FC<DimensionGuideProps> = ({ guide }) => {
  const isHorizontal = guide.orientation === 'horizontal';
  const middleX = (guide.start.x + guide.end.x) / 2;
  const middleY = (guide.start.y + guide.end.y) / 2;

  return (
    <Group listening={false}>
      <Line
        points={[guide.start.x, guide.start.y, guide.end.x, guide.end.y]}
        stroke="#1683ff"
        strokeWidth={1}
        strokeScaleEnabled={false}
      />

      <Line
        points={
          isHorizontal
            ? [
                guide.start.x,
                guide.start.y - TICK_SIZE,
                guide.start.x,
                guide.start.y + TICK_SIZE,
              ]
            : [
                guide.start.x - TICK_SIZE,
                guide.start.y,
                guide.start.x + TICK_SIZE,
                guide.start.y,
              ]
        }
        stroke="#1683ff"
        strokeWidth={1}
        strokeScaleEnabled={false}
      />

      <Line
        points={
          isHorizontal
            ? [
                guide.end.x,
                guide.end.y - TICK_SIZE,
                guide.end.x,
                guide.end.y + TICK_SIZE,
              ]
            : [
                guide.end.x - TICK_SIZE,
                guide.end.y,
                guide.end.x + TICK_SIZE,
                guide.end.y,
              ]
        }
        stroke="#1683ff"
        strokeWidth={1}
        strokeScaleEnabled={false}
      />

      <Text
        x={isHorizontal ? middleX - 35 : middleX + 4}
        y={isHorizontal ? middleY - 16 : middleY - 8}
        width={70}
        text={guide.label}
        align="center"
        fontSize={10}
        fill="#1683ff"
        rotation={isHorizontal ? 0 : -90}
        listening={false}
      />
    </Group>
  );
};

export default DimensionGuide;
